(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-best-sellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Cart helpers - find cart sections, swap fresh HTML, open drawer */
    function findCartSectionIds() {
      var ids = [];
      document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
        var raw = el.id.replace('shopify-section-', '');
        var hay = (raw + ' ' + (el.className || '')).toLowerCase();
        if (
          hay.indexOf('cart-drawer') !== -1 ||
          hay.indexOf('cart-notification') !== -1 ||
          hay.indexOf('cart-icon') !== -1 ||
          hay.indexOf('cart-bubble') !== -1 ||
          hay.indexOf('mini-cart') !== -1 ||
          hay.indexOf('header-cart') !== -1 ||
          /(^|-)cart(-|$)/.test(raw.toLowerCase())
        ) {
          ids.push(raw);
        }
      });
      return ids;
    }

    function swapSection(sectionId, html) {
      if (!html) return;
      var old = document.getElementById('shopify-section-' + sectionId);
      if (!old) return;
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var wrapper = temp.querySelector('#shopify-section-' + sectionId);
      if (wrapper) {
        old.innerHTML = wrapper.innerHTML;
      } else {
        old.innerHTML = html;
      }
    }

    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      var notification = document.querySelector('cart-notification');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      if (notification && typeof notification.open === 'function') { notification.open(); return; }

      var togglers = [
        '[data-cart-drawer-toggle]',
        '.js-drawer-open-cart',
        '[data-drawer-trigger="cart"]',
        '.cart-toggle',
        '.header__cart',
        '[aria-controls*="cart-drawer"]',
        '[aria-controls*="CartDrawer"]'
      ];
      for (var i = 0; i < togglers.length; i++) {
        var btn = document.querySelector(togglers[i]);
        if (btn && typeof btn.click === 'function') {
          btn.click();
          return;
        }
      }

      var events = ['cart:refresh', 'cart:open', 'cart:updated', 'cart:added', 'theme:cart:open', 'ajaxProduct:added'];
      events.forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
        document.body.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      });
    }

    function init(scope) {
      var root = scope || document;
      var forms = root.querySelectorAll('.bb-bestsellers form[data-bb-atc]');
      forms.forEach(function (form) {
        if (form.dataset.bbAtcReady === 'true') return;
        form.dataset.bbAtcReady = 'true';
        form.addEventListener('submit', handleSubmit);
      });
    }

    function handleSubmit(e) {
      e.preventDefault();
      var form = e.currentTarget;
      var button = form.querySelector('button[type="submit"]');
      if (!button || button.disabled) return;

      var labelEl = button.querySelector('.bb-bestsellers__btn-label, .bb-spring__btn-label') || button;
      var originalLabel = labelEl.textContent;

      button.disabled = true;
      button.classList.add('bb-bestsellers__btn--loading');
      labelEl.textContent = 'Adding...';

      var cartSectionIds = findCartSectionIds();
      var formData = new FormData(form);
      if (cartSectionIds.length > 0) {
        formData.append('sections', cartSectionIds.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function (data) {
          if (data.sections && typeof data.sections === 'object') {
            Object.keys(data.sections).forEach(function (sid) {
              swapSection(sid, data.sections[sid]);
            });
          }

          var countSelectors = [
            '[data-cart-count]', '.cart-count', '.cart-count-bubble',
            '.cart-link__bubble-num', '.header__cart-count',
            '#cart-icon-bubble span[aria-hidden="true"]'
          ];
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              countSelectors.forEach(function (sel) {
                document.querySelectorAll(sel).forEach(function (el) {
                  el.textContent = cart.item_count;
                });
              });
            });

          button.classList.remove('bb-bestsellers__btn--loading');
          button.classList.add('bb-bestsellers__btn--added');
          labelEl.textContent = 'Added';

          openCartDrawer();

          setTimeout(function () {
            button.classList.remove('bb-bestsellers__btn--added');
            labelEl.textContent = originalLabel;
            button.disabled = false;
          }, 2200);
        })
        .catch(function (err) {
          console.error('[BB Bestsellers ATC]', err);
          button.classList.remove('bb-bestsellers__btn--loading');
          labelEl.textContent = (err && err.description) ? err.description : 'Try Again';
          setTimeout(function () {
            labelEl.textContent = originalLabel;
            button.disabled = false;
          }, 2400);
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector('.bb-bestsellers')) init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Cart helpers - Section Rendering API approach */
    function findCartSectionIds() {
      var ids = [];
      document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
        var raw = el.id.replace('shopify-section-', '');
        var hay = (raw + ' ' + (el.className || '')).toLowerCase();
        if (
          hay.indexOf('cart-drawer') !== -1 ||
          hay.indexOf('cart-notification') !== -1 ||
          hay.indexOf('cart-icon') !== -1 ||
          hay.indexOf('cart-bubble') !== -1 ||
          hay.indexOf('mini-cart') !== -1 ||
          hay.indexOf('header-cart') !== -1 ||
          /(^|-)cart(-|$)/.test(raw.toLowerCase())
        ) {
          ids.push(raw);
        }
      });
      return ids;
    }

    function swapSection(sectionId, html) {
      if (!html) return;
      var old = document.getElementById('shopify-section-' + sectionId);
      if (!old) return;
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var wrapper = temp.querySelector('#shopify-section-' + sectionId);
      if (wrapper) {
        old.innerHTML = wrapper.innerHTML;
      } else {
        old.innerHTML = html;
      }
    }

    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      var notification = document.querySelector('cart-notification');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      if (notification && typeof notification.open === 'function') { notification.open(); return; }

      var togglers = [
        '[data-cart-drawer-toggle]',
        '.js-drawer-open-cart',
        '[data-drawer-trigger="cart"]',
        '.cart-toggle',
        '.header__cart',
        '[aria-controls*="cart-drawer"]',
        '[aria-controls*="CartDrawer"]'
      ];
      for (var i = 0; i < togglers.length; i++) {
        var btn = document.querySelector(togglers[i]);
        if (btn && typeof btn.click === 'function') {
          btn.click();
          return;
        }
      }

      var events = ['cart:refresh', 'cart:open', 'cart:updated', 'cart:added', 'theme:cart:open', 'ajaxProduct:added'];
      events.forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
        document.body.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      });
    }

    function init(scope) {
      var root = scope || document;
      var forms = root.querySelectorAll('.bb-look form[data-bb-atc]');
      forms.forEach(function (form) {
        if (form.dataset.bbAtcReady === 'true') return;
        form.dataset.bbAtcReady = 'true';
        form.addEventListener('submit', handleSubmit);
      });
    }

    function handleSubmit(e) {
      e.preventDefault();
      var form = e.currentTarget;
      var button = form.querySelector('button[type="submit"]');
      if (!button || button.disabled) return;

      button.disabled = true;
      button.classList.add('bb-look__btn--loading');

      var cartSectionIds = findCartSectionIds();
      var formData = new FormData(form);
      if (cartSectionIds.length > 0) {
        formData.append('sections', cartSectionIds.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function (data) {
          if (data.sections && typeof data.sections === 'object') {
            Object.keys(data.sections).forEach(function (sid) {
              swapSection(sid, data.sections[sid]);
            });
          }

          var countSelectors = [
            '[data-cart-count]', '.cart-count', '.cart-count-bubble',
            '.cart-link__bubble-num', '.header__cart-count',
            '#cart-icon-bubble span[aria-hidden="true"]'
          ];
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              countSelectors.forEach(function (sel) {
                document.querySelectorAll(sel).forEach(function (el) {
                  el.textContent = cart.item_count;
                });
              });
            });

          button.classList.remove('bb-look__btn--loading');
          button.classList.add('bb-look__btn--added');

          openCartDrawer();

          setTimeout(function () {
            button.classList.remove('bb-look__btn--added');
            button.disabled = false;
          }, 2200);
        })
        .catch(function (err) {
          console.error('[BB Look ATC]', err);
          button.classList.remove('bb-look__btn--loading');
          setTimeout(function () {
            button.disabled = false;
          }, 2400);
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector('.bb-look')) init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spring-refresh-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* Cart helpers - find cart sections, swap fresh HTML, open drawer */
    function findCartSectionIds() {
      var ids = [];
      document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
        var raw = el.id.replace('shopify-section-', '');
        var hay = (raw + ' ' + (el.className || '')).toLowerCase();
        if (
          hay.indexOf('cart-drawer') !== -1 ||
          hay.indexOf('cart-notification') !== -1 ||
          hay.indexOf('cart-icon') !== -1 ||
          hay.indexOf('cart-bubble') !== -1 ||
          hay.indexOf('mini-cart') !== -1 ||
          hay.indexOf('header-cart') !== -1 ||
          /(^|-)cart(-|$)/.test(raw.toLowerCase())
        ) {
          ids.push(raw);
        }
      });
      return ids;
    }

    function swapSection(sectionId, html) {
      if (!html) return;
      var old = document.getElementById('shopify-section-' + sectionId);
      if (!old) return;
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var wrapper = temp.querySelector('#shopify-section-' + sectionId);
      if (wrapper) {
        old.innerHTML = wrapper.innerHTML;
      } else {
        old.innerHTML = html;
      }
    }

    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      var notification = document.querySelector('cart-notification');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      if (notification && typeof notification.open === 'function') { notification.open(); return; }

      var togglers = [
        '[data-cart-drawer-toggle]',
        '.js-drawer-open-cart',
        '[data-drawer-trigger="cart"]',
        '.cart-toggle',
        '.header__cart',
        '[aria-controls*="cart-drawer"]',
        '[aria-controls*="CartDrawer"]'
      ];
      for (var i = 0; i < togglers.length; i++) {
        var btn = document.querySelector(togglers[i]);
        if (btn && typeof btn.click === 'function') {
          btn.click();
          return;
        }
      }

      var events = ['cart:refresh', 'cart:open', 'cart:updated', 'cart:added', 'theme:cart:open', 'ajaxProduct:added'];
      events.forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
        document.body.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      });
    }

    function init(scope) {
      var root = scope || document;
      var forms = root.querySelectorAll('form[data-bb-atc]');
      forms.forEach(function (form) {
        if (form.dataset.bbAtcReady === 'true') return;
        form.dataset.bbAtcReady = 'true';
        form.addEventListener('submit', handleSubmit);
      });

      // Smooth scroll for in-section anchor links (Hero CTA -> product grid)
      var anchors = root.querySelectorAll('a[href^="#"]');
      anchors.forEach(function (a) {
        if (a.dataset.bbAnchorReady === 'true') return;
        a.dataset.bbAnchorReady = 'true';
        a.addEventListener('click', function (e) {
          var href = a.getAttribute('href');
          if (!href || href === '#' || href.length < 2) return;
          var target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.replaceState(null, '', href);
          }
        });
      });
    }

    function handleSubmit(e) {
      e.preventDefault();
      var form = e.currentTarget;
      var button = form.querySelector('button[type="submit"]');
      if (!button || button.disabled) return;

      var labelEl = button.querySelector('.bb-spring__btn-label') || button;
      var originalLabel = labelEl.textContent;

      button.disabled = true;
      button.classList.add('bb-spring__btn--loading');
      labelEl.textContent = 'Adding...';

      var cartSectionIds = findCartSectionIds();
      var formData = new FormData(form);
      if (cartSectionIds.length > 0) {
        formData.append('sections', cartSectionIds.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function (data) {
          if (data.sections && typeof data.sections === 'object') {
            Object.keys(data.sections).forEach(function (sid) {
              swapSection(sid, data.sections[sid]);
            });
          }

          var countSelectors = [
            '[data-cart-count]', '.cart-count', '.cart-count-bubble',
            '.cart-link__bubble-num', '.header__cart-count',
            '#cart-icon-bubble span[aria-hidden="true"]'
          ];
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              countSelectors.forEach(function (sel) {
                document.querySelectorAll(sel).forEach(function (el) {
                  el.textContent = cart.item_count;
                });
              });
            });

          button.classList.remove('bb-spring__btn--loading');
          button.classList.add('bb-spring__btn--added');
          labelEl.textContent = 'Added';

          openCartDrawer();

          setTimeout(function () {
            button.classList.remove('bb-spring__btn--added');
            labelEl.textContent = originalLabel;
            button.disabled = false;
          }, 2200);
        })
        .catch(function (err) {
          console.error('[BB Spring Refresh ATC]', err);
          button.classList.remove('bb-spring__btn--loading');
          labelEl.textContent = (err && err.description) ? err.description : 'Try Again';
          setTimeout(function () {
            labelEl.textContent = originalLabel;
            button.disabled = false;
          }, 2400);
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList.contains('section-bb-spring-refresh')) {
        init(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
